(() => {
  const activateMegaTabs = (scope = document) => {
    scope.querySelectorAll('[data-nav-foxtale]').forEach((menu) => {
      const tabs = Array.from(menu.querySelectorAll('[data-nav-tab]'));
      const panels = Array.from(menu.querySelectorAll('[data-nav-panel]'));
      if (!tabs.length || !panels.length) return;

      const activate = (id) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.navTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.navPanel === id));
      };

      if (tabs[0]?.dataset.navTab) activate(tabs[0].dataset.navTab);
      tabs.forEach((tab) => {
        ['mouseenter', 'focus'].forEach((eventName) => tab.addEventListener(eventName, () => activate(tab.dataset.navTab)));
        tab.addEventListener('click', () => activate(tab.dataset.navTab));
      });
    });
  };

  const loadFallbackCollectionImages = async (scope = document) => {
    const nodes = Array.from(scope.querySelectorAll('[data-nav-collection-media][data-collection-handle]'));
    const handles = [...new Set(nodes.map((node) => node.dataset.collectionHandle).filter(Boolean))];
    if (!handles.length) return;

    const cache = new Map();
    await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=1`, { credentials: 'same-origin' });
        if (!response.ok) return;
        const data = await response.json();
        const product = data?.products?.[0];
        const src = product?.image?.src || product?.images?.[0]?.src || product?.featured_image?.src || product?.featured_image;
        if (src) cache.set(handle, src);
      } catch (_) {}
    }));

    nodes.forEach((node) => {
      const src = cache.get(node.dataset.collectionHandle);
      if (!src || node.querySelector('img')) return;
      const img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = '';
      img.src = src;
      node.innerHTML = '';
      node.appendChild(img);
      node.classList.remove('is-empty');
    });
  };

  const init = (scope = document) => {
    activateMegaTabs(scope);
    loadFallbackCollectionImages(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
